import { reatomAsync, withDataAtom } from "@reatom/async";
import { ProductSourceDtoSourceEnum } from "definitions/product-storage";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";
import { fetchProductDetail } from "src/store/fetchers/getProductDetailRequest";

import {
  getCachedProductPrice,
  ProductPriceResponse,
  setCachedProductPrice,
} from "../idbs/productPriceIndexedDb";

export const getProductDetailFromStoragePage = reatomAsync(
  async (_ctx, productId: number) => fetchProductDetail(productId),
  "getProductDetailFromStoragePage",
).pipe(withDataAtom(null), withIsLoadingAtom());

type LoadProductArgs = {
  spuId: string;
  platform: ProductSourceDtoSourceEnum;
  force: boolean;
};

export const loadProductPrice = reatomAsync(
  async (ctx, { spuId, platform, force }: LoadProductArgs) => {
    const key = `${platform}:` + spuId;
    if (!force) {
      const cached = await getCachedProductPrice(key);
      if (cached) {
        return cached;
      }
    }
    let data: ProductPriceResponse | undefined;
    switch (platform) {
      case ProductSourceDtoSourceEnum.Poizon:
        data = await API.poizonProductApi
          .poizonApiControllerGetProductInfo(Number(spuId))
          .then((res) => res.data);
        break;

      case ProductSourceDtoSourceEnum.Dewu:
        data = await API.poizonPublicApi
          .dewuControllerGetProductDetailWithPrice(Number(spuId))
          .then((res) => res.data);
        break;

      case ProductSourceDtoSourceEnum.Goat:
        data = await API.goatApi
          .goatGetBuyBarData(spuId)
          .then((res) => res.data);
        break;
    }

    if (data) await setCachedProductPrice(key, data);

    return data;
  },
  "loadProductPrice",
).pipe(withDataAtom(null), withIsLoadingAtom());
